module.exports = __webpack_public_path__ + "static/media/award.07cf0ef9.png";